import {mapSetState, SetState} from "../../util/FormHandlers";
import {Grid} from "@mui/material";
import NeighbourhoodMultiselect from "../neighbourhood-select/NeighbourhoodMultiselect";
import React, {useMemo} from "react";
import {INeighbourhood} from "../../api/Model";
import {useNeighbourhoodStore} from "../../api/NeighbourhoodStore";
import {RemoteValue, useRemoteValue} from "../../util/RemoteValue";


export function useNeighbourhoodsOrDefault(neighbourhoods?: INeighbourhood[]): INeighbourhood[] {
    const neighbourhoodStore = useNeighbourhoodStore();
    const neighbourhoodsRV = useMemo(() => {
        return neighbourhoods ? RemoteValue.fromValue(neighbourhoods) : neighbourhoodStore.remoteValue;
    }, [neighbourhoodStore, neighbourhoods]);
    return useRemoteValue(neighbourhoodsRV, []);
}

export function NeighbourhoodsFilter<Filter extends { neighbourhoods: INeighbourhood[] }>({filter, setFilter, allNeighbourhoods}: {
    filter: Filter,
    setFilter: SetState<Filter>,
    allNeighbourhoods?: INeighbourhood[],
}) {
    const neighbourhoods = useNeighbourhoodsOrDefault(allNeighbourhoods);

    const setNeighbourhoods = useMemo(
        () => mapSetState(setFilter, 'neighbourhoods'),
        [setFilter],
    );

    return (
        <Grid size={{lg: 3, md: 4, xs: 12}}>
            <NeighbourhoodMultiselect
                fullWidth
                id="neighbourhood-select"
                label="Neighbourhoods"

                neighbourhoods={filter.neighbourhoods}
                setNeighbourhoods={setNeighbourhoods}
                allNeighbourhoods={neighbourhoods}
            />
        </Grid>
    );
}